import { useTranslation } from 'react-i18next';
import { useStore } from 'context/StoreContext';
import Button from 'components/Button';
import Container from 'components/Container';
import { WhatsAppIcon } from 'components/icons';
import { whatsappUrl } from 'utils/whatsapp';

/** "Ask us" band: WhatsApp first (how Indonesian shoppers ask), email second. */
export default function ContactBlock({ block }) {
  const { t } = useTranslation();
  const { identity } = useStore();
  const wa = whatsappUrl(identity.whatsapp, block.whatsappText);
  if (!wa && !identity.email) return null;
  const id = `blk-${block.id}`;
  return (
    <section aria-labelledby={id} className="py-16 lg:py-28">
      <Container className="grid gap-6 lg:grid-cols-12 lg:gap-10">
        <h2 id={id} className="font-display text-[2.1rem] leading-[1.05] text-ink sm:text-5xl lg:col-span-6 lg:text-[3.6rem]">
          {block.title}
        </h2>
        <div className="lg:col-span-5 lg:col-start-8 lg:pt-2">
          <p className="text-pretty text-[17px] leading-relaxed text-muted">{block.body}</p>
          <div className="mt-7 flex flex-wrap items-center gap-x-6 gap-y-4">
            {wa && (
              <Button href={wa} target="_blank" rel="noopener noreferrer" size="lg">
                <WhatsAppIcon className="h-5 w-5" />
                {block.whatsappLabel || t('whatsapp.cta')}
              </Button>
            )}
            {identity.email && (
              <a href={`mailto:${identity.email}`} className="link text-[15px]">
                {identity.email}
              </a>
            )}
          </div>
        </div>
      </Container>
    </section>
  );
}
